import { ExternalIcon } from "@icons/ExternalIcon";
import { MapControl } from "./MapControl";
import { useCallback } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { useUserLocation } from "@hooks/useUserLocation/useUserLocation";

const UserLocationControl = () => {
  const map = useMap();
  const { getUserLocation } = useUserLocation();

  const handlePress = useCallback(async () => {
    const location = await getUserLocation();
    if (!location) {
      return;
    }

    map?.setCenter({
      lat: location.coordinates.latitude,
      lng: location.coordinates.longitude,
    });
  }, [getUserLocation, map]);

  if (!navigator.geolocation) {
    return null;
  }

  return (
    <MapControl
      items={[
        {
          icon: <ExternalIcon svgName="current-location" />,
          onPress: handlePress,
          key: "current-location",
        },
      ]}
    />
  );
};

export { UserLocationControl };
